import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { API } from '../api'
import enunciadoImg from '../assets/enunciadoCAPJota.png'
import enunciadoEmbaralhadoImg from '../assets/enunciadoCAPJota_embaralhado.png'

export function MenuPage() {
  const navigate = useNavigate()

  // Turma com perguntas embaralhadas não mostra atributos, então usa a instrução "Leia cada Manifestação"
  const [perguntasEmbaralhadas, setPerguntasEmbaralhadas] = useState<boolean | null>(null)

  useEffect(() => {
    const turmaId = sessionStorage.getItem('turma')
    if (!turmaId) { setPerguntasEmbaralhadas(false); return }
    axios.get(`${API.ASSESSMENT}/questions?turmaId=${turmaId}`)
      .then(res => setPerguntasEmbaralhadas(Boolean(res.data.perguntasEmbaralhadas)))
      .catch(() => setPerguntasEmbaralhadas(false))
  }, [])

  const userInfo = {
    name: sessionStorage.getItem('nome') || 'Usuário',
    email: sessionStorage.getItem('email') || 'usuario@exemplo.com',
    role: sessionStorage.getItem('role') || 'user'
  }

  const handleLogout = () => {
    sessionStorage.clear()
    navigate('/login')
  }

  return (
    <div style={{ 
      backgroundColor: 'white', 
      color: '#333', 
      minHeight: '100dvh', 
      width: '100%', 
      maxWidth: '100%',
      overflowX: 'hidden',
      margin: 0, 
      padding: 0,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <header style={{ 
        backgroundColor: '#0e1d72', 
        padding: 'max(12px, env(safe-area-inset-top, 0px)) clamp(14px, 4vw, 20px) 12px', 
        color: 'white', 
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px 14px',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: 'clamp(20px, 5vw, 24px)' }}>cap jota</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0, flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
            {userInfo.name} ({userInfo.email})
          </span>
          <button 
            onClick={handleLogout}
            style={{ 
              background: 'transparent', 
              color: 'white', 
              border: '1px solid white', 
              padding: '6px 14px', 
              cursor: 'pointer', 
              borderRadius: '4px',
              minHeight: '44px',
              display: 'inline-flex',
              alignItems: 'center',
              fontWeight: 600,
              fontSize: '13px'
            }}
          >
            Sair
          </button>
        </div>
      </header>

      <div style={{ 
        flex: 1, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: 'clamp(16px, 4vw, 24px) clamp(12px, 3vw, 20px)',
        boxSizing: 'border-box',
        width: '100%'
      }}>
        <div style={{ 
          maxWidth: '800px',
          width: '100%'
        }}>
          <div style={{ textAlign: 'center', marginBottom: 'clamp(24px, 5vw, 40px)' }}>
            <h1 style={{ 
              fontSize: 'clamp(22px, 5vw, 36px)',
              fontWeight: 'bold', 
              color: '#0e1d72', 
              margin: '0 0 10px' 
            }}>
              BMI Assessment CAP JOTA
            </h1>
            <p style={{ fontSize: 'clamp(15px, 3.5vw, 18px)', color: '#666', margin: 0 }}>
              Sistema de Avaliação Comportamental
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))',
            gap: 'clamp(16px, 4vw, 25px)',
            marginBottom: 'clamp(24px, 5vw, 40px)'
          }}>
            {/* Assessment Card */}
            <div 
              onClick={() => navigate('/assessment')}
              style={{ 
                backgroundColor: '#f8f9fa', 
                border: '2px solid #0e1d72', 
                borderRadius: '12px', 
                padding: 'clamp(18px, 5vw, 30px)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)'
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(14, 29, 161, 0.15)'
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}
            >
              {/* Imagem de instruções do sistema original (WebContent/menu/img/enunciadoCAPJota.png);
                  turmas embaralhadas usam a variante sem a divisão por atributo */}
              {perguntasEmbaralhadas === null ? (
                <div style={{ width: '100%', maxWidth: '480px', aspectRatio: '1448 / 885', margin: '0 auto 15px' }} />
              ) : (
                <img
                  src={perguntasEmbaralhadas ? enunciadoEmbaralhadoImg : enunciadoImg}
                  alt={perguntasEmbaralhadas
                    ? 'Instruções do assessment: leia cada manifestação'
                    : 'Instruções do assessment: leia cada atributo e identifique a percepção grupal predominante'}
                  style={{ display: 'block', width: '100%', maxWidth: '480px', height: 'auto', margin: '0 auto 15px' }} />
              )}
              <h2 style={{ 
                fontSize: '24px', 
                fontWeight: 'bold', 
                color: '#0e1d72', 
                marginBottom: '15px' 
              }}>
                Assessment
              </h2>
              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                Preencher o questionário de avaliação comportamental
              </p>
              <div style={{ 
                marginTop: '20px', 
                fontSize: '14px', 
                color: '#0e1d72', 
                fontWeight: 'bold' 
              }}>
                Clique para iniciar →
              </div>
            </div>

            {/* Facilitador Card */}
            {(userInfo.role === 'admin' || userInfo.role === 'facilitador') && (
              <div 
                onClick={() => navigate('/facilitador')}
                style={{ 
                  backgroundColor: '#f8f9fa', 
                  border: '2px solid #28a745', 
                  borderRadius: '12px', 
                  padding: 'clamp(18px, 5vw, 30px)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)'
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.15)'
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                }}
              >
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>👥</div>
                <h2 style={{ 
                  fontSize: '24px', 
                  fontWeight: 'bold', 
                  color: '#28a745', 
                  marginBottom: '15px' 
                }}>
                  Facilitador
                </h2>
                <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                  Gerenciar assessments e gerar relatórios debriefing
                </p>
                <div style={{ 
                  marginTop: '20px', 
                  fontSize: '14px', 
                  color: '#28a745', 
                  fontWeight: 'bold' 
                }}>
                  Clique para acessar →
                </div>
              </div>
            )}

            {/* Admin Card */}
            {userInfo.role === 'admin' && (
              <div 
                onClick={() => navigate('/admin')}
                style={{ 
                  backgroundColor: '#f8f9fa', 
                  border: '2px solid #dc3545', 
                  borderRadius: '12px', 
                  padding: 'clamp(18px, 5vw, 30px)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)'
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(220, 53, 69, 0.15)'
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                }}
              >
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>⚙️</div>
                <h2 style={{ 
                  fontSize: '24px', 
                  fontWeight: 'bold', 
                  color: '#dc3545', 
                  marginBottom: '15px' 
                }}>
                  Admin
                </h2>
                <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                  Administrar turmas, usuários e configurações do sistema
                </p>
                <div style={{ 
                  marginTop: '20px', 
                  fontSize: '14px', 
                  color: '#dc3545', 
                  fontWeight: 'bold' 
                }}>
                  Clique para acessar →
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
